import React from 'react'
import { useSelector } from 'react-redux'
import useSessionsStatusPolling from '../../hooks/useSessionsStatusPolling'
import useJobsPolling from '../../hooks/useJobsPolling'

import SessionsTable from './SessionsTable'
import { selectNewCloneLeaguesSessionURL } from '../../reducers/clone_leagues_sessions'
import SessionsPagination from './SessionsPagination'
import SessionsStatusModal from './SessionsStatusModal'

const SessionsDashboard = () => {
  useSessionsStatusPolling()
  useJobsPolling()

  const newCloneLeaguesSessionURL = useSelector(selectNewCloneLeaguesSessionURL)

  return (
    <>
      <div className="cls-dashboard">
        <div className="cls-header">
          <div className="cls-title-container">
            <h1 className="cls-title">
              {window.I18n.t('clone_leagues_sessions.sessions_dashboard.sessions')}
            </h1>
            <button
              className="cls-new-session-button"
              onClick={() => window.location.href = newCloneLeaguesSessionURL}
            >
              {window.I18n.t('clone_leagues_sessions.sessions_dashboard.create_new_session')}
            </button>
          </div>
          <p className="cls-subtitle">
            {window.I18n.t('clone_leagues_sessions.sessions_dashboard.description')}
          </p>
        </div>
        <SessionsTable />
        <SessionsPagination />
      </div>
      <SessionsStatusModal/>
    </>
  )
}

export default SessionsDashboard
